export default "__VITE_ASSET__CwwWvcS$__"